import { isTicketSelectionExcludedInListings } from '../components/EventDetails/ConversionBarContainer/isTicketSelectionExcludedInListings';
import { useEventBasicInformationContext, useTicketContext } from '../contexts';
import { useFeatureFlag } from '../contexts/FeatureFlags/FeatureFlagsContext';
import { normalizeDisqualificationKeys } from '../contexts/TicketContext/helpers';

export const useCondensedCheckoutExperiment = () => {
    const {
        ticketData: { compactCheckoutDisqualifications },
        externalTicketsAreAvailable = false,
    } = useTicketContext();
    const shouldShowOnlyDefaultCheckoutOnlineEvents = useFeatureFlag<boolean>(
        'shouldShowOnlyDefaultCheckoutOnlineEvents',
    );
    const {
        place: { isOnline },
        salesStatus,
        isRepeating,
    } = useEventBasicInformationContext();

    const onlyDefaultCheckoutForOnlineEvents =
        isOnline && shouldShowOnlyDefaultCheckoutOnlineEvents;

    const isTicketSelectionExcluded = isTicketSelectionExcludedInListings({
        ...normalizeDisqualificationKeys(compactCheckoutDisqualifications),
        externalTicketsAreAvailable,
        salesStatus,
        onlyDefaultCheckoutForOnlineEvents:
            onlyDefaultCheckoutForOnlineEvents || false,
    });
    console.log(
        'compactCheckoutDisqualifications',
        compactCheckoutDisqualifications,
    );
    console.log('isTicketSelectionExcluded', isTicketSelectionExcluded);
    console.log('isRepeating', isRepeating);
    console.log(
        'onlyDefaultCheckoutForOnlineEvents',
        onlyDefaultCheckoutForOnlineEvents,
    );
    console.log('isOnline', isOnline);
    console.log('salesStatus', salesStatus);
    return !isRepeating && !isTicketSelectionExcluded;
};
